import React, { useContext, useReducer } from "react";

const sanitizeKey = (key) => {
  return key.replace(/[.#$\/\[\]]/g, "_");
};

const updateScores = (scores, llm, category, markets) => {
  llm.forEach((item) => {
    if (!scores[item]) {
      scores[item] = {};
    }
    category.forEach((cat) => {
      if (!scores[item][cat]) {
        scores[item][cat] = [];
        if (markets) {
          scores[item][cat] = {};
          markets.forEach((market) => {
            scores[item][cat][market] = [];
          });
        }
      }
    });
  });
  return { ...scores };
};

const TASK_STATUS = {
  SUCCESS: "success",
  ERROR: "error",
  PENDING: "pending",
};

const TASKS = {
  BRAND_DESCRIPTION: "branddescription",
  BRAND_THEMES: "brandthemes",
  BRAND_SNIPPETS: "brandsnippets",
  BRAND_SCORE: "brandscore",
  RANK_SCORE: "rankscore",
  CATEGORY_DIMENSION: "categorydimensions",
  CORE_ATTRIBUTES: "coreattributes",
  COMPETITORS: "competitors",
  ATTRIBUTES: "attributes",
};
// const updateStatus = (status, task, category, taskstatus, competitor ) => {
//     let newstatus =JSON.parse(JSON.stringify(status.data));
//     if(task === TASKS.BRAND_SCORE || task === TASKS.RANK_SCORE){
//       if(competitor){
//         competitor = competitor.toLowerCase();
//         newstatus[category][competitor] = taskstatus;
//       }
//     } else {
//       newstatus[category][task] = taskstatus;
//     }

//     console.log("updateStatus",task, category, taskstatus, competitor)

//     newstatus[category].completedtasks = Object.keys(newstatus[category]).map((key) => newstatus[category][key] === TASK_STATUS.SUCCESS ? 1 : 0).reduce((acc, next) => acc + next, 0);
//    // newstatus[category].erroredtasks = Object.keys(newstatus[category]).map((key) => newstatus[category][key] === TASK_STATUS.ERROR ? 1 : 0).reduce((prev, next) => prev + next, 0);
//     newstatus[category].isCompleted = (newstatus[category].completedtasks + newstatus[category].erroredtasks) === newstatus[category].total;
//     let totalTasks = Object.values(newstatus).reduce((acc, curr) => acc + curr.total, 0);
//     let completedTasks = Object.values(newstatus).reduce((acc, curr) => acc + curr.completedtasks, 0);
//     console.log("totaltasks",totalTasks,completedTasks,newstatus)
//     return {
//       data: newstatus,
//       totaltasks :totalTasks,
//       completedtasks: completedTasks,
//       loading: totalTasks !== completedTasks
//     }
// }

// const initializeStatus = (status, category, competitors, llm, primary_llm, entity, markets) => {
//   let newstatus = {...status.data};
//   let otherMarkets = [...markets]
//   otherMarkets.shift();
//   category.forEach((cat) => {
//     if (!newstatus[cat]) {
//       newstatus[cat] = {
//         isCompleted: false,
//         completedtasks: 0,
//         erroredtasks: 0, // 4 x 2  + 1 // 2+ 1
//         total: (6 + ((competitors[cat]?.length+1) * llm.length + otherMarkets.length) + (llm.length + otherMarkets.length))-1,
//         branddescription: TASK_STATUS.PENDING,
//         brandthemes: TASK_STATUS.PENDING,
//         brandsnippets: TASK_STATUS.PENDING,
//         categorydimensions:TASK_STATUS.PENDING,
//         coreattributes: TASK_STATUS.PENDING,
//         attributes: TASK_STATUS.PENDING
//       }
// //  6*(4*2+3)+2+3
// //  6+11+5 22
//        // brand score for primary market and primary LLM and all competitor( including brand)
//       let competitorsStatus = {};
//       competitors[cat]?.forEach((comp) =>  {
//         let competitor = comp.name.toLowerCase();
//         let key = primary_llm + '-' + competitor + '-' + markets[0];
//         competitorsStatus[key] = TASK_STATUS.PENDING
//       })

//       // brand score for secondary LLMs
//       llm.map((model) => {
//         if(model !== primary_llm){
//           let key = model.toLowerCase() + '-' + entity+ '-'+ markets[0];
//           competitorsStatus[key] = TASK_STATUS.PENDING
//         }
//       })

//       // rank score for all LLMs for primary market
//         llm.map((model) => {
//             let key = 'rank'+ model.toLowerCase() + '-' + entity+ '-'+ markets[0];;
//             competitorsStatus[key] = TASK_STATUS.PENDING
//         })

//       // rank score for primary LLM for other markets
//         otherMarkets.map((market) => {
//             let key = 'rank'+primary_llm + '-' + entity+ '-'+ market;
//             competitorsStatus[key] = TASK_STATUS.PENDING
//         })

//       // brand score for primary LLM for other markets
//         otherMarkets.map((market) => {
//             let key = primary_llm + '-' + entity+ '-'+ market;
//             competitorsStatus[key] = TASK_STATUS.PENDING
//         })

//       console.log('competitorsStatus', competitorsStatus)
//       newstatus[cat] = { ...newstatus[cat], ...competitorsStatus }

//     }
//   });
//   return {
//     data: newstatus,
//     loading: false,
//     totaltasks :
//       Object.values(newstatus).reduce((acc, curr) => acc + curr.total, 0),
//     completedtasks:
//       Object.values(newstatus).reduce((acc, curr) => acc + curr.completedtasks, 0),
//   }
// }

const updateStatus = (totalTasks, completedTask) => {
  return {
    loading: false,
    totaltasks: totalTasks,
    completedtasks: completedTask,
  };
};

const initializeStatus = (status, category, competitors, llm, primary_llm, entity, markets, type) => {
  const rank = llm.length * markets.length;
  // const sentiment = (4 * llm.length) + ((markets.length - 1) * 4);
  const sentiment = (3 * llm.length) + (markets.length * llm.length);
  const categoryDimension = llm.length;
  const coreAttribute = 4 * llm.length;
  const description = llm.length;
  const theme = llm.length * 6;
  const snippet = llm.length * 6;
  const attribute = 4 * llm.length;
  const taxonomy = llm.length;

  let total = 0;
  if (type === "brand") {
    total =
      (rank +
        sentiment +
        categoryDimension +
        coreAttribute +
        description +
        theme +
        snippet +
        attribute) *
      category.length;
  } else {
    total =
      (rank +
        sentiment +
        categoryDimension +
        taxonomy +
        description +
        theme +
        snippet +
        attribute) *
      category.length;
  }

  return {
    loading: false,
    totaltasks: total,
    completedtasks: 0,
  };
};

const sanitizeObject = (obj) => {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }
  if (Array.isArray(obj)) {
    return obj.map(sanitizeObject);
  }
  return Object.keys(obj).reduce((result, key) => {
    const sanitizedKey = sanitizeKey(key);
    result[sanitizedKey] = sanitizeObject(obj[key]);
    return result;
  }, {});
};

const uniqueArray = (array) => {
  return array.filter(
    (obj, index, self) => index === self.findIndex((o) => o?.name === obj?.name)
  );
};

const INITIAL_STATE = {
  name: "",
  entity: "",
  category: [],
  market: "",
  markets: [],
  llm: ["gpt-4o"],
  primary_llm: "gpt-4o",
  type: "brand",
  domain: "",
  transactionStatus: "",
  loading: false,
  competitors: [],
  brand_scores: {},
  category_dimensions: {},
  core_attributes: {},
  sources: {},
  brand_description: {},
  brand_snippets: {},
  brand_themes: [],
  positive_negative_attributes: {},
  top_products: [],
  taxonomies: {},
  is_launched: false,
  abort_launch: false,
  location: "United States",
  occupation: "",
  attributes: [],
  category_taxonomies: [],
  product_prefs: [],
  pre_category_dimensions: [],
  selectedCompetitor:0,
  rank_scores: {},
  /*this flag is  use to show checkbox in component so that user can select it for include it in report screenShot*/
  showReportCheckbox: false,
  /*it consist data for component of which we enable checkbox with  filter llm,market,category,competitors */
  selectedSection: {},
  status: {},
};

export const DiscoveryContext = React.createContext({
  location: "",
  domain: "",
  occupation: "",
  attributes: [],
  product_prefs: [],
  state: {},
  status: {},
  category: [],
  market: "",
  markets: [],
  llm: [],
  type: "",
  loading: false,
  updateId: () => {},
  updateLoading: () => {},
  brand_scores: {},
  category_taxonomies: [],
  updateCategoryTaxonomies: () => {},
  updateBrandScores: () => {},
  sources: [],
  updateSources: () => {},
  core_attributes: [],
  updateCoreAttributes: () => {},
  competitors: [],
  updatedCompetitors: () => {},
  category_dimensions: {},
  updateCategoryDimensions: () => {},
  brand_description: {},
  updateBrandDescription: () => {},
  brand_snippets: [],
  updateBrandSnippets: () => {},
  positive_negative_attributes: {},
  updatePositiveNegativeAttributes: () => {},
  top_products: [],
  updatedTopProducts: () => {},
  name: "",
  entity: "",
  pre_category_dimensions: [],
  rank_scores: {},
  updateEntity: () => {},
  updateName: () => {},
  updateType: () => {},
  is_launched: false,
  updatedLaunched: () => {},
  updateEntireState: () => {},
  resetState: () => {},
  refreshState: () => {},
  brand_themes: [],
  updatedBrandThemes: () => {},
  updateCategory: () => {},
  updateMarket: () => {},
  updateLLM: () => {},
  taxonomies: {},
  updatedTaxonomies: () => {},
  abort_launch: false,
  updateAbortLaunch: () => {},
  updateLocation: () => {},
  updateOccupation: () => {},
  updateAttribute: () => {},
  updateProductPrefs: () => {},
  updatePreCategoryDimensions: () => {},
  updateRankScores: () => {},
  replaceBrandScores: () => {},
  initializeStatus: () => {},
  updateDomain: () => {},
  updateTransactionId: () => {},
  updateTransactionStatus: () => {},
  updateTransactionHistory: () => {},
  updateSelectedLLM: () => {},
  updateSelectedCompetitor: () => {},
  updateSelectedCategory: () => {},
  updateSelectedMarket: () => {},
});

function discoveryReducer(state = INITIAL_STATE, action) {
  if (action.type === "UPDATE_BRAND_SCORE") {
    const { req, res,sourceSentiment, completedTaskCount } = action.payload;
    const { data, index } = res;
    const { llm, category, market } = req;
    console.log("llm category, market ", llm, category, market);
    if (!state.entity) return state;
    const updatedBrandScores = [...state.brand_scores[llm][category][market]];

    const rankingScores =
      state.rank_scores[llm][category][market].data &&
      state.rank_scores[llm][category][market].data.length > 0
        ? [...state.rank_scores[llm][category][market].data]
        : [];
    const rankDataForBrandProduct = rankingScores[index];
    if (rankDataForBrandProduct && data && data?.name) {
      updatedBrandScores[index] = {
        name: data.name,
        rank: rankDataForBrandProduct.score,
        favorability: data.favorability,
        total: +rankDataForBrandProduct.score + +data.favorability,
        extras: {
          ...data.extras,
          ...state.rank_scores[llm][category][market].extras,
          rank: [rankDataForBrandProduct],
        },
      };
    } else {
      updatedBrandScores[index] = data;
    }
    const existingBrandScores = { ...state.brand_scores };
    existingBrandScores[llm][category][market] = updatedBrandScores;
    return {
      ...state,
      brand_scores: existingBrandScores,
      // status: updateStatus(state.status, TASKS.BRAND_SCORE, category, TASK_STATUS.SUCCESS, llm+'-'+data.name+'-'+market)
      status: updateStatus(state.status.totaltasks, completedTaskCount),
    };
  }
  if (action.type === "UPDATE_SOURCES") {
    const updatedSources = { ...state.sources }
     const {  res,req } = action.payload;
    const { llm, category, market } = req;
    if (!state.entity) return state;
    updatedSources[llm][category][market] = updatedSources[llm][category][market].concat(res);
    return {
      ...state,
      sources: updatedSources,
    };
  }
  if (action.type === "INITIALIZE_STATUS") {
    const {
      status,
      category,
      competitors,
      llm,
      primary_llm,
      entity,
      markets,
      type,
    } = state;
    return {
      ...state,
      status: initializeStatus(
        status,
        category,
        competitors,
        llm,
        primary_llm,
        entity,
        markets,
        type
      ),
    };
  }
  if (action.type === "UPDATE_CORE_ATTRIBUTES") {
    const core_attributes = { ...state.core_attributes };
    const { category, llm, completedTaskCount } = action.payload;
    if (!state.entity) return state;
    core_attributes[llm][category] = action.payload;
    return {
      ...state,
      core_attributes: core_attributes,
      // status: updateStatus(state.status, TASKS.CORE_ATTRIBUTES, category, TASK_STATUS.SUCCESS)
      status: updateStatus(state.status.totaltasks, completedTaskCount),
    };
  }
  if (action.type === "UPDATE_COMPETITORS") {
    console.log("UPDATE_COMPETITORS category", state.category);
    return {
      ...state,
      // competitors: uniqueArray(action.payload),
      competitors: action.payload,
    };
  }
  if (action.type === "UPDATE_CATEGORY_DIMENSIONS") {
    const category_dimensions = { ...state.category_dimensions };
    const { category, llm, completedTaskCount } = action.payload;
    if (!state.entity) return state;
    category_dimensions[llm][category] = action.payload;
    return {
      ...state,
      category_dimensions: category_dimensions,
      // status: updateStatus(state.status, TASKS.CATEGORY_DIMENSION, category, TASK_STATUS.SUCCESS)
      status: updateStatus(state.status.totaltasks, completedTaskCount),
    };
  }
  if (action.type === "UPDATE_BRAND_DESCRIPTION") {
    let updated_brand_description = { ...state.brand_description };
    let { req, res, completedTaskCount } = action.payload;
    let { category, llm } = req;
    if (!state.entity) return state;
    updated_brand_description[llm][category] = res;
    return {
      ...state,
      brand_description: updated_brand_description,
      // score : updateStatus(state.status, TASKS.BRAND_DESCRIPTION, category, TASK_STATUS.SUCCESS)
      status: updateStatus(state.status.totaltasks, completedTaskCount),
    };
  }
  if (action.type === "UPDATE_BRAND_SNIPPETS") {
    let updated_brand_snippets = { ...state.brand_snippets };
    let { req, res, completedTaskCount } = action.payload;
    let { category, llm } = req;
    if (!state.entity) return state;
    updated_brand_snippets[llm][category] = res;
    return {
      ...state,
      brand_snippets: updated_brand_snippets,
      // status: updateStatus(state.status, TASKS.BRAND_SNIPPETS, category,TASK_STATUS.SUCCESS)
      status: updateStatus(state.status.totaltasks, completedTaskCount),
    };
  }
  // if (action.type === "UPDATE_POSITVE_NEGATIVE_ATTRIBUTES") {
  //   let updated_positive_negative_attributes = { ...state.positive_negative_attributes };
  //   let { req, res, completedTaskCount } = action.payload;
  //   let { category, llm } = req;
  //   if (!state.entity) return state;
  //   updated_positive_negative_attributes[llm][category] = res;
  //   return {
  //     ...state,
  //     positive_negative_attributes: updated_positive_negative_attributes,
  //     // status: updateStatus(state.status, TASKS.ATTRIBUTES, category, TASK_STATUS.SUCCESS)
  //     status: updateStatus(state.status.totaltasks, completedTaskCount)
  //   };
  // }
  if (action.type === "UPDATE_POSITVE_NEGATIVE_ATTRIBUTES") {
    let updated_positive_negative_attributes = {
      ...state.positive_negative_attributes,
    };
    let { req, res, completedTaskCount } = action.payload;
    let { category, llm } = req;

    if (!state.entity) return state;

    // Ensure nested structure exists
    if (!updated_positive_negative_attributes[llm]) {
      updated_positive_negative_attributes[llm] = {};
    }
    if (!updated_positive_negative_attributes[llm][category]) {
      updated_positive_negative_attributes[llm][category] = [];
    }

    // Instead of overwrite, append new competitor object
    updated_positive_negative_attributes[llm][category] = [
      ...updated_positive_negative_attributes[llm][category],
      res,
    ];

    return {
      ...state,
      positive_negative_attributes: updated_positive_negative_attributes,
      status: updateStatus(state.status.totaltasks, completedTaskCount),
    };
  }

  if (action.type === "UPDATE_TOP_PRODUCTS") {
    return {
      ...state,
      top_products: action.payload,
    };
  }
  if (action.type === "UPDATE_ENTITY") {
    return {
      // ...INITIAL_STATE,
      ...state,
      entity: action.payload,
    };
  }
  if (action.type === "UPDATE_LAUNCHED") {
    return {
      ...state,
      is_launched: action.payload,
    };
  }
  if (action.type === "UPDATE_STATE") {
    return {
      ...action.payload,
    };
  }
  if (action.type === "RESET_STATE") {
    return {
      ...INITIAL_STATE,
      type: state.type,
      transactionHistory: state.transactionHistory,
      state: { ...INITIAL_STATE },
    };
  }
  if (action.type === "REFRESH_STATE") {
    return {
      ...INITIAL_STATE,
      type: state.type,
      transactionHistory: state.transactionHistory,
      loading: true,
      is_launched: true,
      state: { ...INITIAL_STATE },
    };
  }
  if (action.type === "UPDATE_BRAND_THEMES") {
    let updated_brand_themes = { ...state.brand_themes };
    let { req, res, completedTaskCount } = action.payload;
    let { category, llm } = req;
    if (!state.entity) return state;
    updated_brand_themes[llm][category] = res;
    return {
      ...state,
      brand_themes: updated_brand_themes,
      // status: updateStatus(state.status, TASKS.BRAND_THEMES, category,TASK_STATUS.SUCCESS)
      status: updateStatus(state.status.totaltasks, completedTaskCount),
    };
  }
  if (action.type === "UPDATE_NAME") {
    return {
      ...state,
      name: action.payload,
    };
  }
  if (action.type === "UPDATE_CATEGORY") {
    const category = action.payload;
    const llm = [...state.llm];
    const primary_llm = state.primary_llm;
    const brand_scores = { ...state.brand_scores };
    const rank_scores = { ...state.rank_scores };
    const markets = [...state.markets];
    const taxonomies = { ...state.taxonomies };
    return {
      ...state,
      category: action.payload,
      brand_scores: updateScores(brand_scores, llm, category, markets),
      rank_scores: updateScores(rank_scores, llm, category, markets),
      brand_snippets: updateScores({ ...state.brand_snippets }, llm, category),
      brand_description: updateScores(
        { ...state.brand_description },
        llm,
        category
      ),
      brand_themes: updateScores({ ...state.brand_themes }, llm, category),
      positive_negative_attributes: updateScores({ ...state.attributes }, llm, category),
      category_dimensions: updateScores({ ...state.category_dimensions }, llm, category),
      core_attributes: updateScores({ ...state.core_attributes }, llm, category),
      sources: updateScores({ ...state.sources }, llm, category,markets),
      taxonomies: updateScores(taxonomies, llm, category),
    };
  }
  if (action.type === "UPDATE_MARKET") {
    let markets = action.payload.map((m) => m.trim());
    const llm = state.llm;
    const category = state.category;
    const brand_scores = { ...state.brand_scores };
    const rank_scores = { ...state.rank_scores };
    const primary_llm = state.primary_llm;
    const taxonomies = { ...state.taxonomies };
    let market = markets[0];
    return {
      ...state,
      market: market,
      markets: markets,
      brand_scores: updateScores(brand_scores, llm, category, markets),
      rank_scores: updateScores(rank_scores, llm, category, markets),
      brand_snippets: updateScores({ ...state.brand_snippets }, llm, category),
      brand_description: updateScores(
        { ...state.brand_description },
        llm,
        category
      ),
      brand_themes: updateScores({ ...state.brand_themes }, llm, category),
      positive_negative_attributes: updateScores({ ...state.attributes }, llm, category),
      category_dimensions: updateScores({ ...state.category_dimensions }, llm, category),
      core_attributes: updateScores({ ...state.core_attributes }, llm, category),
      sources: updateScores({ ...state.sources }, llm, category,markets),
      taxonomies: updateScores(taxonomies, llm, category),
    };
  }
  if (action.type === "UPDATE_LLM") {
    const llm = action.payload;
    const category = state.category;
    const brand_scores = { ...state.brand_scores };
    const rank_scores = { ...state.rank_scores };
    const primary_llm = state.primary_llm;
    const markets = [...state.markets];
    const taxonomies = { ...state.taxonomies };
    return {
      ...state,
      llm: action.payload,
      brand_scores: updateScores(brand_scores, llm, category, markets),
      rank_scores: updateScores(rank_scores, llm, category, markets),
      brand_snippets: updateScores({ ...state.brand_snippets }, llm, category),
      brand_description: updateScores(
        { ...state.brand_description },
        llm,
        category
      ),
      brand_themes: updateScores({ ...state.brand_themes }, llm, category),
      positive_negative_attributes: updateScores({ ...state.attributes }, llm, category),
      category_dimensions: updateScores({ ...state.category_dimensions }, llm, category),
      core_attributes: updateScores({ ...state.core_attributes }, llm, category),
      sources: updateScores({ ...state.sources }, llm, category,markets),
      taxonomies: updateScores(taxonomies, llm, category),
    };
  }

  if (action.type === "UPDATE_COMPIEITIER") {
    return { ...state, selectedCompetitor: action.payload };
  }

  if (action.type === "UPDATE_PRIMARY_LLM") {
    return {
      ...state,
      primary_llm: action.payload,
    };
  }
  if (action.type === "UPDATE_TYPE") {
    return {
      ...state,
      type: action.payload,
    };
  }
  if (action.type === "UPDATE_TAXONOMY") {
    let updated_taxonomies = { ...state.taxonomies };
    let { req, res, completedTaskCount } = action.payload;
    let { category, llm } = req;
    if (!state.entity) return state;
    updated_taxonomies[llm][category] = res;
    return {
      ...state,
      taxonomies: updated_taxonomies,
      // status: updateStatus(state.status, TASKS.CORE_ATTRIBUTES, category, TASK_STATUS.SUCCESS)
      status: updateStatus(state.status.totaltasks, completedTaskCount),
    };
  }
  if (action.type === "UPDATE_ID") {
    return {
      ...state,
      id: action.payload,
    };
  }
  if (action.type === "UPDATE_TRANSACTIONID") {
    return {
      ...state,
      transactionId: action.payload,
    };
  }
  if (action.type === "UPDATE_TRANSACTIONSTATUS") {
    return {
      ...state,
      transactionStatus: action.payload,
    };
  }

  if (action.type === "UPDATE_TRANSACTIONHISTORY") {
    if (action.payload === null || action.payload.clear) {
      return { ...state, transactionHistory: [] };
    }
    if (action.payload.replace) {
      return { ...state, transactionHistory: action.payload.data || [] };
    }

    return {
      ...state,
      transactionHistory: [
        ...(state.transactionHistory || []),
        ...(action.payload || []),
      ],
    };
  }

  if (action.type === "UPDATE_SELECTEDLLM") {
    return {
      ...state,
      selectedLLM: action.payload,
    };
  }
  if (action.type === "UPDATE_SELECTEDCATRGORY") {
    return {
      ...state,
      selectedCategory: action.payload,
    };
  }
  if (action.type === "UPDATE_SELECTEDMARKET") {
    return {
      ...state,
      selectdMarket: action.payload,
    };
  }
  if (action.type === "ABORT_LAUNCH") {
    return {
      ...state,
      abort_launch: action.payload,
    };
  }

  if (action.type === "UPDATE_DOMAIN") {
    return {
      ...state,
      domain: action.payload,
    };
  }

  if (action.type === "UPDATE_LOCATION") {
    return {
      ...state,
      location: action.payload,
    };
  }
  if (action.type === "UPDATE_OCCUPATION") {
    return {
      ...state,
      occupation: action.payload,
    };
  }
  if (action.type === "UPDATE_ATTRIBUTE") {
    return {
      ...state,
      attributes: action.payload,
    };
  }
  if (action.type === "UPDATE_CATEGORY_TAXONOMIES") {
    let updated_category_taxonomies = { ...state.category_taxonomies };
    let { req, res } = action.payload;
    if (!req) return state;
    let { category } = req;
    updated_category_taxonomies[category] = res;
    return {
      ...state,
      category_taxonomies: updated_category_taxonomies,
    };
  }
  if (action.type === "UPDATE_PRODUCT_PREFS") {
    return {
      ...state,
      product_prefs: action.payload,
    };
  }
  if (action.type === "UPDATE_PRE_CATEGORY_DIMENSIONS") {
    return {
      ...state,
      pre_category_dimensions: action.payload,
    };
  }
  if (action.type === "UPDATE_LOADING") {
    return {
      ...state,
      loading: action.payload,
    };
  }
  if (action.type === "UPDATE_RANK_SCORES") {
    const { req, res, completedTaskCount } = action.payload;
    const { data, extras } = res;
    const { llm, category, market } = req;
    if (!state.entity) return state;
    let updatedBrandScores = [...state.brand_scores[llm][category][market]];

    Array.isArray(data) &&
      data.forEach((item, index) => {
        let brandIndexItem = updatedBrandScores[index];
        if (brandIndexItem && brandIndexItem.favorability) {
          updatedBrandScores[index] = {
            name: item.name,
            rank: item.score,
            favorability: brandIndexItem.favorability,
            total: +item.score + +brandIndexItem.favorability,
            extras: {
              ...extras,
              ...brandIndexItem.extras,
              rank: [item],
            },
          sentimentSources:brandIndexItem.sentimentSources,
          };
        } else {
          updatedBrandScores[index] = {
            ...updatedBrandScores[index],
            name: item.name,
            rank: item.score,
            extras: {
              ...extras,
              rank: [item],
            },
          };
        }
      });

    const existingBrandScores = { ...state.brand_scores };
    existingBrandScores[llm][category][market] = updatedBrandScores;

    const updatedRankScores = { ...state.rank_scores };
    updatedRankScores[llm][category][market] = action.payload.res;
    return {
      ...state,
      rank_scores: updatedRankScores,
      brand_scores: existingBrandScores,
      // status: updateStatus(state.status, TASKS.RANK_SCORE, category, TASK_STATUS.SUCCESS,'rank'+llm+'-'+state.entity+'-'+market)
      status: updateStatus(state.status.totaltasks, completedTaskCount),
    };
  }
  if (action.type === "REPLACE_BRAND_SCORES") {
    return {
      ...state,
      brand_scores: action.payload,
    };
  }

  /*action for button  click of report checkbox*/
  if (action.type === "Check_Report_Checkbox") {
    return {
      ...state,
      showReportCheckbox: action.payload,
    };
  }


  if(action.type==="cancel_selection"){
    return {
      ...state,
      showReportCheckbox:false,
      selectedSection:{}
    };

  }
  /*handle action of user click on checkbox  of component so need to check is key exist and updates the values*/
  if (action.type === "click_component_checkbox") {
    const { uniqueKey, filter, checked } = action.payload;
    if (checked) {
      delete state.selectedSection?.[uniqueKey];
    } else {
      if (filter.tab === "nev_brandoverview")
        state.selectedSection[uniqueKey] = {
          llm: state.selectedLLM,
          category: state.selectedCategory,
          market: state.selectdMarket,
          ...filter,
        };
      else if (filter.tab === "nev_competitiveoverview"){
        state.selectedSection[uniqueKey] = {
          llm: state.selectedLLM,
          category: state.selectedCategory,
          competitor: state?.selectedCompetitor ?? "",
          ...filter,
        };
      }
      else if (filter.tab === "nev_marketoverview")
        state.selectedSection[uniqueKey] = {
          llm: state.selectedLLM,
          category: state.selectedCategory,
          market: state.selectdMarket,
          ...filter,
        };
        else{
           state.selectedSection[uniqueKey] = {
          llm: state.selectedLLM,
          ...filter,
        };

        }
    }
    return {
      ...state,
    };
  }

  return state;
}

export default function DiscoveryProvider({ children }) {
  const [state, dispatch] = useReducer(discoveryReducer, INITIAL_STATE);

  function updateLoading(payload) {
    dispatch({ type: "UPDATE_LOADING", payload });
  }

  function updateId(payload) {
    dispatch({ type: "UPDATE_ID", payload });
  }

  function updateBrandScores(payload) {
    dispatch({ type: "UPDATE_BRAND_SCORE", payload });
  }

  function updateSources(payload) {
    dispatch({ type: "UPDATE_SOURCES", payload });
  }

  function updateCoreAttributes(payload) {
    dispatch({ type: "UPDATE_CORE_ATTRIBUTES", payload });
  }

  function updatedCompetitors(payload) {
    dispatch({ type: "UPDATE_COMPETITORS", payload });
  }

  function updateCategoryDimensions(payload) {
    dispatch({ type: "UPDATE_CATEGORY_DIMENSIONS", payload });
  }

  function updateBrandDescription(payload) {
    dispatch({ type: "UPDATE_BRAND_DESCRIPTION", payload });
  }

  function updateBrandSnippets(payload) {
    dispatch({ type: "UPDATE_BRAND_SNIPPETS", payload });
  }

  function updatePositiveNegativeAttributes(payload) {
    dispatch({ type: "UPDATE_POSITVE_NEGATIVE_ATTRIBUTES", payload });
  }

  function updatedTopProducts(payload) {
    dispatch({ type: "UPDATE_TOP_PRODUCTS", payload });
  }

  function updateEntity(payload) {
    dispatch({ type: "UPDATE_ENTITY", payload });
  }

  function updatedLaunched(payload) {
    dispatch({ type: "UPDATE_LAUNCHED", payload });
  }

  function updateEntireState(payload) {
    dispatch({ type: "UPDATE_STATE", payload });
  }

  function updateTransactionId(payload) {
    dispatch({ type: "UPDATE_TRANSACTIONID", payload });
  }

  function updateTransactionStatus(payload) {
    dispatch({ type: "UPDATE_TRANSACTIONSTATUS", payload });
  }

  function updateTransactionHistory(payload) {
    dispatch({ type: "UPDATE_TRANSACTIONHISTORY", payload });
  }

  function updateSelectedLLM(payload) {
    dispatch({ type: "UPDATE_SELECTEDLLM", payload });
  }
  function updateSelectedCategory(payload) {
    dispatch({ type: "UPDATE_SELECTEDCATRGORY", payload });
  }
  function updateSelectedMarket(payload) {
    dispatch({ type: "UPDATE_SELECTEDMARKET", payload });
  }

  function updateSelectedCompetitor(payload) {
    dispatch({ type: "UPDATE_COMPIEITIER", payload });
  }
  function resetState() {
    dispatch({ type: "RESET_STATE" });
  }
  function refreshState() {
    dispatch({ type: "REFRESH_STATE" });
  }

  function updatedBrandThemes(payload) {
    dispatch({ type: "UPDATE_BRAND_THEMES", payload });
  }

  function updateName(payload) {
    dispatch({ type: "UPDATE_NAME", payload });
  }

  function updateCategory(payload) {
    dispatch({ type: "UPDATE_CATEGORY", payload });
  }

  function updateMarket(payload) {
    dispatch({ type: "UPDATE_MARKET", payload });
  }

  function updateLLM(payload) {
    dispatch({ type: "UPDATE_LLM", payload });
  }

  function updatePrimaryLLM(payload) {
    dispatch({ type: "UPDATE_PRIMARY_LLM", payload });
  }

  function updateType(payload) {
    dispatch({ type: "UPDATE_TYPE", payload });
  }

  function updatedTaxonomies(payload) {
    dispatch({ type: "UPDATE_TAXONOMY", payload });
  }

  function updateLocation(payload) {
    dispatch({ type: "UPDATE_LOCATION", payload });
  }

  function updateOccupation(payload) {
    dispatch({ type: "UPDATE_OCCUPATION", payload });
  }

  function updateAttribute(payload) {
    dispatch({ type: "UPDATE_ATTRIBUTE", payload });
  }

  function updateRankScores(payload) {
    dispatch({ type: "UPDATE_RANK_SCORES", payload });
  }

  function updateDomain(payload) {
    dispatch({ type: "UPDATE_DOMAIN", payload });
  }

  function updateAbortLaunch(payload) {
    dispatch({ type: "ABORT_LAUNCH", payload });

    setTimeout(() => {
      updateLoading(false);
      updatedLaunched(false);
      resetState();
    }, 100);
  }

  function replaceBrandScores(payload) {
    dispatch({ type: "REPLACE_BRAND_SCORES", payload });
  }

  function updateCategoryTaxonomies(payload) {
    dispatch({ type: "UPDATE_CATEGORY_TAXONOMIES", payload });
  }

  function updateProductPrefs(payload) {
    dispatch({ type: "UPDATE_PRODUCT_PREFS", payload });
  }

  function updatePreCategoryDimensions(payload) {
    dispatch({ type: "UPDATE_PRE_CATEGORY_DIMENSIONS", payload });
  }

  function initialize(payload) {
    dispatch({ type: "INITIALIZE", payload });
  }

  function initializeStatus(payload) {
    dispatch({ type: "INITIALIZE_STATUS", payload });
  }

  /*handle  report checkbox  button click*/
  function showReportCheckbox(payload) {
    dispatch({ type: "Check_Report_Checkbox", payload });
  }

  /*handle  component checkbox  click*/
  function clickComponentCheckbox(payload) {
    dispatch({ type: "click_component_checkbox", payload });
  }

  function cancelSelection(payload){
    dispatch({type:"cancel_selection"})
  }

  return (
    <DiscoveryContext.Provider
      value={{
        state: state,
        updateId,
        location: state.location,
        attributes: state.attributes,
        occupation: state.occupation,
        loading: state.loading,
        updateLoading: updateLoading,
        rank_scores: state.rank_scores,
        product_prefs: state.product_prefs,
        brand_scores: state.brand_scores,
        sources: state.sources,
        core_attributes: state.core_attributes,
        competitors: state.competitors,
        category_dimensions: state.category_dimensions,
        brand_description: state.brand_description,
        brand_snippets: state.brand_snippets,
        brand_themes: state.brand_themes,
        positive_negative_attributes: state.positive_negative_attributes,
        top_products: state.top_products,
        entity: state.entity,
        name: state.name,
        category: state.category,
        market: state.market,
        llm: state.llm,
        primary_llm: state.primary_llm,
        is_launched: state.is_launched,
        taxonomies: state.taxonomies,
        type: state.type,
        pre_category_dimensions: state.pre_category_dimensions,
        abort_launch: state.abort_launch,
        category_taxonomies: state.category_taxonomies,
        status: state.status,
        markets: state.markets,
        domain: state.domain,
        updateBrandScores,
        updateSources,
        updateCoreAttributes,
        updatedCompetitors,
        updateCategoryDimensions,
        updateBrandDescription,
        updateBrandSnippets,
        updatePositiveNegativeAttributes,
        updatedTopProducts,
        updateEntity,
        updateName,
        updatedLaunched,
        updateEntireState,
        resetState,
        refreshState,
        updatedBrandThemes,
        updateCategory,
        updateMarket,
        updateLLM,
        updatePrimaryLLM,
        updateType,
        updatedTaxonomies,
        updateAbortLaunch,
        updateAttribute,
        updateLocation,
        updateOccupation,
        updateCategoryTaxonomies,
        updateProductPrefs,
        updatePreCategoryDimensions,
        updateRankScores,
        updateDomain,
        replaceBrandScores,
        initialize,
        initializeStatus,
        updateTransactionId,
        updateTransactionStatus,
        updateTransactionHistory,
        updateSelectedLLM,
        updateSelectedCategory,
        updateSelectedMarket,
        showReportCheckbox,
        clickComponentCheckbox,
        updateSelectedCompetitor,
        cancelSelection
      }}
    >
      {children}
    </DiscoveryContext.Provider>
  );
}

/*In some case  uniqueKey is only depend on only one thing or factor like in competitor overview the competitor summary only depend
  on selectedCategory  no other on selectedLLM ,SelectedCompetitor, selectedMarket so no meaning of includes those in uniqueKey*/
export function useIsSelectedSection({
  id,
  tab = "nev_brandoverview",
  uniqueKey,
}) {
  const discoveryCtx = useContext(DiscoveryContext);
  const selectedLLM = discoveryCtx.state.selectedLLM;
  const selectedCategory = discoveryCtx.state.selectedCategory;
  const selectedMarket = discoveryCtx.state.selectdMarket;
  const selectedCompetitor = discoveryCtx.state.selectedCompetitor;

  if (!uniqueKey) {
    if (tab === "nev_brandoverview") {
      uniqueKey = `${id}_${selectedLLM ?? ""}_${selectedCategory ?? ""}_${
        selectedMarket ?? ""
      }`;
    } else if (tab === "nev_competitiveoverview") {
      uniqueKey = `${id}_${selectedLLM ?? ""}_${
        selectedCategory ?? ""
      }_${selectedCompetitor}`;
    } else if (tab === "nev_brandoverview") {
      uniqueKey = `${id}_${selectedLLM ?? ""}_${selectedCategory ?? ""}_${
        selectedMarket ?? ""
      }`;
    }
  }
  const selectedContextRef = discoveryCtx.state?.selectedSection ?? {};

  return { checked: selectedContextRef?.[uniqueKey] ? true : false, uniqueKey };
}
